@if (expandMenuDrawer$ | async) {}
<div
  class="h-full st-side-menu-drawer overflow-hidden no-print"
  stSideDrawer
  [isOpen]="isOpen()"
  [direction]="'left'"
  [maxWidth]="this.maxWidth()"
>
  <st-mobile-main-sections-left-menu
    [homeButton]="homeButton()"
    [navigationList]="navigationList()"
    [profile]="profile()"
    [settingURL]="settingURL()"
    [tools]="tools()"
    (onSelectSection)="selectionItem($event)"
    [class.drawer-open]="!showContent()"
    [class.drawer-closed]="showContent()"
    class="drawer-hide-when-closed"
    [style.width]="this.maxWidth()"
    (onToolsOpen)="openTools()"
  ></st-mobile-main-sections-left-menu>
  <st-menu-drawer-section-content
    [navigationItem]="this.navigationItem()"
    [style.width]="this.maxWidth()"
    (onHideContent)="hideContent()"
    [class.drawer-open]="showContent()"
    [class.drawer-closed]="!showContent()"
    [tools]="toolsContent()"
  ></st-menu-drawer-section-content>
</div>
